module.exports = __webpack_public_path__ + "img/car.c3ad8c7c.gif";